<template>
    <div class="page-container">
        <img class="buy-nft-bg" src="../images/nft_bg.webp">
        <div class="buy-nft-container">
            <img class="nft-top-bar-img" src="../images/nft_top_bar.svg" alt="top bar">

            <div class="carousel-container">
                <div class="carousel-viewport">
                    <div class="carousel-wrapper"
                         :style="carouselStyle"
                         @transitionend="handleTransitionEnd">
                        <div v-for="(item, index) in displayItems"
                             :key="`item-${index}`"
                             class="carousel-item"
                             :class="{ 'carousel-item-active': isActiveItem(index) }"
                             :style="{
             backgroundColor: item.color,
             transform: isActiveItem(index) ? 'scale(1.5)' : 'scale(1)',
             zIndex: isActiveItem(index) ? 2 : 1
                 }">
                            <!--                            <div class="nft-card-image-container">-->
                            <img class="nft-card-image" :class="{'disabled-nft-img': item.name === 'LASVEGAS'}" :src=item.cardImg alt="nft card">
                            <!--                            </div>-->

                        </div>
                    </div>
                </div>

                <div class="carousel-controls">
                    <div class="carousel-arrow" @click="prev">←</div>
                    <div class="carousel-arrow" @click="next">→</div>
                </div>

                <div class="carousel-indicators">
                    <div v-for="(item, index) in nftList"
                         :key="`indicator-${index}`"
                         class="carousel-indicator"
                         :class="{active: realIndex === index}"
                         @click="goToSlide(index)"/>
                </div>

            </div>
            <div class="price-display-container">
                <div class="nft-price-header">{{ this.localize('NFT价格') }}</div>
                <div class="nft-price-txt">
                    <span class="price-only">{{ this.currentSelectedItem.price }}</span><span> U</span>
                </div>
            </div>

            <div class="nft-buy-container">
                <div class="amount-picker-container">
                    <div class="amount-header">{{ this.localize('数量') }}</div>
                    <div class="amount-picker">
                        <img class="change-amount-img" src="../images/plus.svg" alt="plus" @click="amountPlus">
                        <div class="change-amount-number">{{ this.currentNftCount }}</div>
                        <img class="change-amount-img" src="../images/minus.svg" alt="minus" @click="amountMinus">
                    </div>
                </div>
                <div class="balance-container">
                    <div class="total-price-container">
                        <div>{{ this.localize('总价') }}</div>
                        <div class="total-price-txt"><p class="price-only">{{ this.totalPrice.toFixed(2) }}</p>
                            <p>U</p></div>
                    </div>
                    <div class="balance-wrapper">
                        <div>{{ this.localize('账户余额') }}</div>
                        <div class="total-price-txt"><p class="price-only">{{ this.myUsdtBalance?.toFixed(2) }}</p>
                            <p>U</p></div>
                    </div>
                </div>
                <div class="buy-nft-btn-container">
                    <div class="buy-nft-btn" @click="startPurchaseNFT" :class="{'disabled-btn': this.canBuy() === false}">{{ this.localize(this.getPurchaseBtnLabel()) }}</div>
                </div>
            </div>

            <div class="refer-container">
                <div class="refer-header">{{ this.localize('推荐地址') }}</div>
                <div class="refer-wallet-address">{{ this.referrerWalletAddressDisplay }}</div>
                <div class="refer-header" v-if="this.getReferLink">{{ this.localize('我的邀请链接') }}</div>
                <div class="refer-wallet-address" v-if="this.getReferLink">{{ this.getReferLink }}</div>

                <div class="refer-nft-btn-container" v-if="this.getReferLink">
                    <div class="buy-nft-btn" @click="copyReferLink">{{ this.localize('复制邀请链接') }}</div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import macauCard from '@/images/nft/macau.webp'
import dubaiCard from '@/images/nft/dubai.webp'
import monacoCard from '@/images/nft/monaco.webp'
import lasvegasCard from '@/images/nft/lasvegas.webp'
import {
    maskBscAddress,
    getUsdtBalance,
    checkAllowance,
    approveUSDT,
    buyNftsWithUSDT,
    usdtEthCall
} from "@/utils/web3Helper";
import {isProd, Tier} from "@/utils/constants";

import {Interactor} from '@/utils/constants';
import {sleep} from '@/utils/methods';
import {showToast} from "@/utils/toastHelper";
import {hideLoading, showLoading} from "@/utils/spinnerHelper";
import {postRequestAsync} from "@/utils/request";
import copy from 'copy-to-clipboard';
import {parseUnits, formatUnits} from 'ethers'
import {v4} from "uuid";


export default {
    name: 'BuyNFTPage',
    props: {
        msg: String
    },
    inject: ['langStore', 'localize'],
    data() {
        return {
            currentIndex: 1,
            transitionEnabled: true,
            isTransitioning: false,
            nftList: [
                {
                    name: 'MACAU',
                    cardImg: macauCard,
                    price: isProd === true ? 100 : 0.01,
                    tier: Tier.Macau,
                    allow: false
                },
                {
                    name: 'DUBAI',
                    cardImg: dubaiCard,
                    price: isProd === true ? 500 : 0.05,
                    tier: Tier.Dubai,
                    allow: false
                },
                {
                    name: 'MONACO',
                    cardImg: monacoCard,
                    price: isProd === true ? 1000 : 0.1,
                    tier: Tier.Monaco,
                    allow: false
                },
                {
                    name: 'LASVEGAS',
                    cardImg: lasvegasCard,
                    price: isProd === true ? 5000 : 0.5,
                    tier: Tier.LasVegas,
                    allow: false
                },
            ],
            currentNftCount: 1,
            myUsdtBalance: 0,
            intervalId: null
        }
    },
    mounted() {
        this.startAutoplay()
        if (this.myWalletAddress) {
            this.setMyUsdtBalance(this.myWalletAddress)
        }
    },
    watch: {
        async myWalletAddress(newVal, oldVal) {
            if (!newVal) return
            if (newVal === oldVal) return

            await this.setMyUsdtBalance(newVal)
        }
    },
    computed: {
        carouselStyle() {
            return {
                transform: `translateX(calc(-${(this.currentIndex + 1) * 33.33}%))`,
                transition: this.transitionEnabled ? 'transform 0.5s ease' : 'none'
            };
        },
        realIndex() {
            // 真实索引，用于指示器高亮显示
            if (this.currentIndex < 2) {
                return this.nftList.length + this.currentIndex - 2;
            } else if (this.currentIndex >= this.nftList.length + 2) {
                return this.currentIndex - this.nftList.length - 2;
            } else {
                return this.currentIndex - 2;
            }
        },
        displayItems() {
            const lastItems = this.nftList.slice(-2);
            const firstItems = this.nftList.slice(0, 2);
            return [...lastItems, ...this.nftList, ...firstItems];
        },
        currentSelectedItem() {
            return this.nftList[this.currentIndex % this.nftList.length]
        },
        totalPrice() {
            return this.currentSelectedItem.price * this.currentNftCount
        },
        referrerWalletAddressDisplay() {
            if (!this.$store.state.referrerWalletAddress) {
                return null
            }
            // return this.$store.state.referrerWalletAddress
            return maskBscAddress(this.$store.state.referrerWalletAddress, '***************************')
        },
        referrerWalletAddress() {
            if (!this.$store.state.referrerWalletAddress) {
                return null
            }
            return this.$store.state.referrerWalletAddress
        },
        myWalletAddress() {
            return this.$store.state.connectedWallet
        },
        getReferLink() {
            return this.$store.state.referLink
        },
    },
    methods: {
        getPurchaseBtnLabel() {
            if (this.currentSelectedItem.name === 'LASVEGAS') {
                return '暂未开放'
            }
            return '购买NFT'
        },
        isActiveItem(index) {
            return index === this.currentIndex + 2;
        },
        goToSlide(index) {
            if (this.isTransitioning) return;

            this.isTransitioning = true;
            this.transitionEnabled = true;
            this.currentIndex = index + 2; // +2 因为我们在前面添加了2个克隆项
            this.restartAutoplay();
        },
        next() {
            if (this.isTransitioning) return;
            this.isTransitioning = true;
            this.transitionEnabled = true;
            this.currentIndex++;
            this.stopAutoplay();
        },
        prev() {
            if (this.isTransitioning) return;
            this.isTransitioning = true;
            this.transitionEnabled = true;
            this.currentIndex--;
            this.stopAutoplay();
        },
        nextAuto() {
            if (this.isTransitioning) return;
            this.isTransitioning = true;
            this.transitionEnabled = true;
            this.currentIndex++;
        },
        prevAuto() {
            if (this.isTransitioning) return;
            this.isTransitioning = true;
            this.transitionEnabled = true;
            this.currentIndex--;
        },
        startAutoplay() {
            this.intervalId = setInterval(() => {
                this.nextAuto();
            }, 3000);
        },
        stopAutoplay() {
            if (this.intervalId) {
                clearInterval(this.intervalId)
            }
        },
        restartAutoplay() {
            this.stopAutoplay();
            this.startAutoplay();
        },
        handleTransitionEnd() {
            this.isTransitioning = false;

            // 如果滑动到了最后的克隆区域
            if (this.currentIndex >= this.nftList.length + 2) {
                // 禁用过渡，立即跳回到前面对应的真实项
                this.transitionEnabled = false;
                this.currentIndex = this.currentIndex - this.nftList.length;
            }
            // 如果滑动到了前面的克隆区域
            else if (this.currentIndex < 2) {
                // 禁用过渡，立即跳回到后面对应的真实项
                this.transitionEnabled = false;
                this.currentIndex = this.nftList.length + this.currentIndex;
            }
        },
        amountPlus() {
            this.stopAutoplay();
            this.currentNftCount++
        },
        amountMinus() {
            this.stopAutoplay();
            if (this.currentNftCount <= 1) {
                return
            }
            this.currentNftCount--
        },
        async setMyUsdtBalance(walletAddress) {
            const balance = await getUsdtBalance(walletAddress)
            console.log(`balance: ${balance}`)
            // this.myUsdtBalance = parseFloat(balance?.formatted)
            this.myUsdtBalance = Number(formatUnits(balance, 18))
        },
        canBuy() {
            if (this.currentSelectedItem.name === 'LASVEGAS') {
                return false
            }
        },
        async startPurchaseNFT() {
            if (this.currentSelectedItem.name === 'LASVEGAS') {
                showToast(this.localize('暂未开放'))
                return
            }
            const loadingId = v4()
            showLoading(this.localize('操作中'), loadingId)
            this.stopAutoplay();
            if (!this.myWalletAddress) {
                showToast(this.localize('未连接钱包'))
                hideLoading(loadingId)
                return
            }
            const balance = await getUsdtBalance(this.myWalletAddress)
            console.log(`balance: ${balance}`)
            this.myUsdtBalance = Number(formatUnits(balance, 18))
            if (this.myUsdtBalance < this.totalPrice) {
                showToast(this.localize('USDT余额不足'))
                hideLoading(loadingId)
                return
            }

            // const allowance = await checkAllowance(this.myWalletAddress, Interactor)

            const allowance = await usdtEthCall('allowance', [this.myWalletAddress, Interactor])
            console.log(`allowance: ${allowance}`)
            // console.log(`Number(formatUnits(allowance, 18): ${Number(formatUnits(allowance, 18))}`)
            console.log(`this.totalPrice: ${this.totalPrice}`)
            if (allowance < parseUnits(this.totalPrice.toString(), 18)) {
                const {success} = await approveUSDT(Interactor, this.totalPrice.toString())
                if (success !== true) {
                    showToast(this.localize('授权失败'))
                    hideLoading(loadingId)
                    return
                }
                showToast(this.localize('授权成功'))
                await sleep(3000)
            }
            const currentSelected = this.currentSelectedItem
            console.log(`this.referrerWalletAddress: ${this.referrerWalletAddress}`)
            console.log(`currentSelected.tier: ${currentSelected.tier}`)
            console.log(`this.currentNftCount: ${this.currentNftCount}`)
            console.log(`allowance: ${allowance}`)
            console.log(`this.totalPrice: ${this.totalPrice}`)

            const sigResult = await postRequestAsync('sig/getBuyNftsSig',
                {
                    buyer: this.myWalletAddress,
                    referrer: this.referrerWalletAddress,
                    count: this.currentNftCount,
                    tier: currentSelected.tier
                })

            if (sigResult?.code !== 200 || sigResult?.msg?.buyNftsNonce === null || !sigResult?.msg?.timestamp || !sigResult?.msg?.deadline || !sigResult?.msg?.signature) {
                showToast(this.localize('获取数据失败'))
                hideLoading(loadingId)
                return
            }

            const nonce = sigResult?.msg?.buyNftsNonce
            const timestamp = sigResult?.msg?.timestamp
            const deadline = sigResult?.msg?.deadline
            const signature = sigResult?.msg?.signature

            const {
                success,
                txHash,
                tokenIds
            } = await buyNftsWithUSDT(currentSelected.tier, this.currentNftCount, this.referrerWalletAddress, nonce, timestamp, deadline, signature)

            if (success !== true) {
                showToast(this.localize('购买失败'))
                hideLoading(loadingId)
                return
            }
            const result = await postRequestAsync('payment/createNftTransaction', {
                tx: txHash,
                nftType: currentSelected.name,
                referrerWalletAddress: this.referrerWalletAddress,
                purchaseWalletAddress: this.myWalletAddress,
                count: this.currentNftCount,
                tokenIds
            })
            showToast(this.localize('购买成功'))
            hideLoading(loadingId)
        },
        copyReferLink() {
            copy(this.getReferLink)
            showToast(this.localize('复制成功'))
        }
    }
}
</script>
<style scoped>

.page-container {
    background-color: #0E1213 !important;
}

.buy-nft-container {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding-top: 7em;
    align-items: center;
    box-sizing: border-box;
    gap: 1em;
    padding-bottom: 5em;
}

.nft-top-bar-img {
    width: 90%;
}

.nft-game-rule-container {
    display: flex;
    flex-direction: column;
    width: 90%;
    border: 2px solid #96FDC8;
    border-radius: 0.6em;
    background-color: rgba(32, 6, 1, 0.5);
    padding: 2em;
    box-sizing: border-box;
    box-shadow: 0 0 8px 2px rgba(150, 253, 200, 0.5);
    gap: 1em;

}

.nft-game-rule-header {
    color: #48FFA1;
    font-size: 2em;
}

.nft-game-rule-item {
    color: #48FFA1;
    font-size: 1.6em;
    text-align: left;
}

.nft-card-image {
    width: 10em;
}



.nft-card-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%
}

.carousel-container {
    position: relative;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    box-sizing: border-box;
    min-height: 26em;
    display: flex;
    justify-content: center;
    align-items: center;
}

.carousel-viewport {
    overflow: hidden;
    padding: 0; /* 为中间放大的项目提供足够空间 */
    height: 100%;
}

.carousel-wrapper {
    display: flex;
    transition: transform 0.5s ease;
    height: 100%;
}

.carousel-item {
    flex: 0 0 33.33%; /* 每个项目占据视口的1/3 */
    box-sizing: border-box;
    transition: all 0.5s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transform-origin: center center;
}

.carousel-item-active {
    z-index: 2;
    padding: 1em;
    border-radius: 0.4em;
}

.carousel-controls {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    z-index: 10;
}

.carousel-arrow {
    width: 40px;
    height: 40px;
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 20px;
    font-weight: bold;
    user-select: none;
}

.carousel-indicators {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 10px;
}

.carousel-indicator {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: rgba(183, 119, 87, 0.4);
    cursor: pointer;
}

.carousel-indicator.active {
    background-color: rgb(183, 119, 87);
}

.nft-price-header {
    color: #FFFFFF;
    font-size: 2em;
}

.price-display-container {
    display: flex;
    flex-direction: column;
    gap: 0.4em;
}

.nft-price-txt {
    color: #ffffff;
    font-size: 2em;
}

.nft-buy-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 1em;
    box-sizing: border-box;
}

.amount-picker-container {
    display: flex;
    flex-direction: column;
    gap: 0.4em;
}

.amount-picker {
    width: 100%;
    border: 1px solid #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 1em;
    box-sizing: border-box;
}

.change-amount-img {
    width: 2em;
}

.change-amount-number {
    color: #ffffff;
    font-size: 2em;
}

.amount-header {
    color: #ffffff;
    font-size: 1.4em;
    width: 100%;
    text-align: start;
}

.price-only {
    color: #48FFA1;
}

.balance-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 1.4em;
    padding: 0.4em 0;
    box-sizing: border-box;
    color: #FFFFFF
}

.balance-wrapper {
    display: flex;
    flex-direction: column;
    align-items: end;
    gap: 0.4em;
}

.total-price-container {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 0.4em;
}

.total-price-txt {
    display: flex;
    flex-direction: row;
}

.total-price-txt > p {
    margin: 0;
}

.buy-nft-btn-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
}


.refer-nft-btn-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 2em;
}

.buy-nft-btn {
    background-color: #48FFA1;
    color: #0E1213;
    font-size: 1.6em;
    height: 2em;
    width: 8em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 1em;
}


.buy-nft-btn.disabled-btn{
    background-color: #91a59a;
}

.buy-nft-btn:active {
    transform: scale(0.95);
}

.nft-card-image.disabled-nft-img{
    opacity: 0.4;
}

.refer-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 1em;
    box-sizing: border-box;
    gap: 0.6em;
}

.refer-header {
    color: #ffffff;
    font-size: 1.6em;
}

.refer-wallet-address {
    color: #ffffff;
    font-size: 1.6em;
    border: 1px solid #ffffff;
    width: 100%;
    text-align: start;
    padding: 0.4em;
    box-sizing: border-box;
}
</style>